import { 
    GET_ALL_MARKETS_BEGIN,
    GET_ALL_MARKETS_SUCCESS,
    GET_ALL_MARKETS_FAIL } from '../action/marketAction'

const initialState = {
    markets:null,
    market:null,
    loading: false,
    error: null, 
}

export default (state = initialState, action) => {
    switch (action.type) {
        case GET_ALL_MARKETS_BEGIN:
            return {
                ...state,
                loading: true,
                error: null
            }
        case GET_ALL_MARKETS_SUCCESS:
            return {
                ...state,
                loading: false,
                markets: action.payload.data
            }
        case GET_ALL_MARKETS_FAIL:
            return {
                ...state,
                loading:false,
                error: action.payload.error.response.data
            }
        default:
            return state
    }
}